import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { CopyProperties } from '../../../blog/models/copy-properties.decorator';
@Component({
    selector: 'detail-fee',
    templateUrl: './detail-fee.html',
    styleUrls: ['./detail-fee.scss', '../tab-detail-fund.scss'],
})

export class DetailFee  implements OnInit, OnDestroy, OnChanges {
    @Input('option') option : OptionFee = new OptionFee();
    @Input('fees') fees: any;
    CODES_UNIT = [{code: 'MONTH', name: 'Theo tháng'}, {code: 'DAY', name: 'Theo ngày'} , {code: 'MONEY', name: 'Theo tiền'}];
    constructor() {
    }
    ngOnInit() {
    }
    ngOnChanges(simpleChanges: SimpleChanges) {
        const changes: any = simpleChanges;
        if (changes.fees.currentValue) {
          const fees = changes.fees.currentValue || [];
          const firstFee = fees[0] || {};
          let valueUnit =  this.option.valueUnit || 'VND';
          if (firstFee.feeUnitType) {
            valueUnit = (this.CODES_UNIT.find(item => item.code === firstFee.feeUnitType) || {name: ''}).name;
          }
          this.option.valueUnit = valueUnit; 
        }
      }
    ngOnDestroy() {
    }
    dismiss() {
        // this.activeModal.dismiss();
    }
}
@CopyProperties()
export class OptionFee {
    valueTitle: string;
    valueUnit: string;
    feeTitle: string;
    feeUnit: string;
    constructor(params?: any) {
      this.valueTitle = '';
      this.valueUnit = '';
      this.feeTitle = '';
      this.feeUnit = '';
    }
}